import { InjectionToken } from '@angular/core';
import { FeatureValue } from './feature-toggler';

export type FeatureConfig = Record<string, FeatureValue>;
/**
 * @ignore
 * Injection token required to add experimental configuration to the toggle
 * router service.
 */
export const FEATURE_CONFIG = new InjectionToken<FeatureConfig>('feature router configuration');
